var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.btnClass,attrs:{"disabled":_vm.disabled || _vm.loading}},[(_vm.loading)?_c('div',{staticClass:"pulse-container"},[_c('div',{staticClass:"pulse-bubble pulse-bubble-1"}),_c('div',{staticClass:"pulse-bubble pulse-bubble-2"}),_c('div',{staticClass:"pulse-bubble pulse-bubble-3"})]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }